import { useState } from 'react'

import { ColorPickerPopover as Picker } from '../../../ColorPicker'
import { Component, ComponentProps } from '../../Component'
import { controls, json, text } from '../../Controls'

export function ColorPickerPopover() {
  const [props, setProps] = useState(() =>
    controls()
      .add(text('colorFormat', 'Hex'))
      .add(
        json('value', {
          value: {
            color: 'blue',
          },
        })
      )
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={Picker}
        name='ColorPickerPopover'
        onChange={handleChange}
      />
      <ComponentProps
        name='ColorPickerPopover'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ColorPickerPopover
